import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { useNavigate, useSearchParams } from 'react-router-dom';

export default function Error() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [params] = useSearchParams();

  const isCanvas = params.get('canvas') === 'true';

  return (
    <div className="min-h-screen flex justify-center p-6">
      <div className="max-w-md w-full space-y-6 text-center">
        <h1 className="text-2xl font-semibold">{t('error.title')}</h1>
        <p className="text-muted-foreground">{t('error.message')}</p>
        {!isCanvas && (
          <div className="flex items-center justify-center gap-3">
            <Button variant="secondary" onClick={() => navigate('/')}>
              {t('error.goHome')}
            </Button>
          </div>
        )}
        {isCanvas && <p className="text-xs text-muted-foreground">{t('authError.canvasNote')}</p>}
      </div>
    </div>
  );
}
